<div class="dataset-column-table">
  @if (loading) {
  <div class="dataset-column-table__loading">Loading columns…</div>
  } @if (!loading) {
  <div class="dataset-column-table__scroll">
    <div class="dataset-column-table__head">
      <span class="dataset-column-table__head-cell dataset-column-table__head-cell--check"></span>
      <span class="dataset-column-table__head-cell dataset-column-table__head-cell--name">Column name</span>
      <span class="dataset-column-table__head-cell dataset-column-table__head-cell--type">Type</span>
      <span class="dataset-column-table__head-cell dataset-column-table__head-cell--description">Description</span>
    </div>
    @for (column of columns; track trackByColumnKey($index, column)) {
    <div class="dataset-column-table__row" [class.dataset-column-table__row--disabled]="!column.selected">
      <span class="dataset-column-table__cell dataset-column-table__cell--check">
        <input type="checkbox" [(ngModel)]="column.selected" [attr.aria-label]="'Include ' + column.name" />
      </span>
      <span class="dataset-column-table__cell dataset-column-table__cell--name">{{ column.name }}</span>
      <span class="dataset-column-table__cell dataset-column-table__cell--type">{{ column.type }}</span>
      <span class="dataset-column-table__cell dataset-column-table__cell--description">{{ column.description }}</span>
    </div>
    } @if (!columns.length) {
    <div class="dataset-column-table__empty">
      No columns available for this datasource yet.
    </div>
    }
  </div>
  }
</div>
